// ========================================
// COMPONENTE CREATEFOLDERMODAL
// Modal para crear nuevas carpetas con validación
// ========================================

import React, { useState } from 'react';

// Componente que recibe:
// - onClose: función para cerrar el modal
// - onConfirm: función para confirmar creación de carpeta
// - parentName: nombre de la carpeta padre (null si se crea en la raíz)
const CreateFolderModal = ({ onClose, onConfirm, parentName }) => {
    // ========================================
    // ESTADOS DEL COMPONENTE
    // ========================================
    const [folderName, setFolderName] = useState('');    // Nombre de la carpeta a crear
    const [error, setError] = useState('');              // Mensaje de error de validación

    // ========================================
    // FUNCIONES DE VALIDACIÓN Y ENVÍO
    // ========================================

    // Manejar envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validar que el nombre no esté vacío
        if (!folderName.trim()) {
            setError('El nombre de la carpeta no puede estar vacío');
            return;
        }

        // Validar longitud máxima
        if (folderName.length > 50) {
            setError('El nombre de la carpeta no puede tener más de 50 caracteres');
            return;
        }

        // Si pasa las validaciones, crear la carpeta
        onConfirm(folderName.trim());
    };

    // Manejar cambios en el input
    const handleChange = (e) => {
        setFolderName(e.target.value);
        if (error) setError('');                         // Limpiar error al escribir
    };

    // ========================================
    // RENDERIZADO DEL MODAL
    // ========================================
    return (
        <div className="modal-overlay2" onClick={onClose}>  {/* Fondo del modal - cerrar al hacer click */}
            <div className="modal2" onClick={(e) => e.stopPropagation()}> {/* Contenido del modal - no cerrar */}
                <div className="modal-header2">
                    <h2 className="modal-title2">
                        {parentName ? `Nueva subcarpeta en "${parentName}"` : 'Crear Nueva Carpeta'}
                    </h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body2">
                        {/* Mostrar errores de validación */}
                        {error && (
                            <div className="alert alert-error">
                                {error}
                            </div>
                        )}

                        {/* Campo de entrada para el nombre */}
                        <div className="form-group2">
                            <label className="form-label2" htmlFor="folderName">
                                Nombre de la carpeta
                            </label>
                            <input
                                id="folderName"
                                type="text"
                                className="form-input"
                                value={folderName}                          // Valor del input
                                onChange={handleChange}                 // Manejar cambios
                                placeholder="Ingresa el nombre de la carpeta"
                                autoFocus                               // Enfocar automáticamente
                                maxLength={50}                         // Límite de caracteres
                            />
                        </div>
                    </div>

                    {/* Botones de acción */}
                    <div className="modal-actions2">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}                          // Cerrar modal sin crear
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={!folderName.trim()}             // Deshabilitar si no hay texto
                        >
                            Crear Carpeta
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateFolderModal;
